var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.726049 24.06V1.87807C0.726049 1.42641 1.12753 1.02492 1.5792 1.02492H6.64793C7.0996 1.02492 7.50108 1.42641 7.50108 1.87807V11.6642L24.263 1.02492C24.5139 0.874367 24.8652 0.874367 25.1162 0.974737C25.3671 1.12529 25.5678 1.42641 25.5678 1.72752V24.06C25.5678 24.3611 25.4173 24.6623 25.1162 24.8128C24.9656 24.863 24.8652 24.9132 24.7147 24.9132C24.5641 24.9132 24.4136 24.863 24.263 24.7626L7.50108 14.1735V24.06C7.50108 24.5117 7.0996 24.9132 6.64793 24.9132H1.5792C1.12753 24.9132 0.726049 24.5619 0.726049 24.06Z","fill":"white"}));
}

Previous.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"none"};

module.exports = Previous;

Previous.default = Previous;
